import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const PageBanner: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTarget(document.getElementById('banner-portal'));
  }, []);

  if (!target) return null;
  return createPortal(<>{children}</>, target);
};

export default PageBanner;
